module.exports = __webpack_public_path__ + "img/street-flower-salesman.4b9d02dd.jpg";